import _ from 'lodash'
import Cookies from 'js-cookie'

import env from '@/env.js'

const NAME = 'dartcome-pr'

const vo = {
  uuid: 'x-nuts-uuid',
  token: 'x-nuts-token',
  account: 'x-nuts-account',
  sid: 'tephra-session-id',
  u: 'nutsbp-token'
}

export default {
  get (path = null) {
    let data = {}
    let json = localStorage.getItem(NAME)
    if (json) {
      try {
        data = JSON.parse(json)
      } catch (e) {
        data = {}
      }
    }
    if (!path) {
      return data
    }
    let v = _.get(data, path, null)
    // 需要特殊處理
    if (!v) {
      switch (path) {
        // 兼容 old dartcome.com
        case 'account':
        case 'token':
          v = Cookies.get(path)
          break
      }
      if (!v && vo[path]) {
        v = Cookies.get(vo[path])
      }
    }
    return v
  },

  /**
   * set
   * @param {string} path null 指的是 整个覆盖
   * @param {any} value
   */
  set (path, value) {
    let data = this.get()
    if (path) {
      _.set(data, path, value)
    } else {
      data = value
    }
    localStorage.setItem(NAME, JSON.stringify(data))

    // 需要特殊處理
    if (vo[path]) {
      Cookies.set(vo[path], value, {domain: `.${env.baseDomain}`})
    }
    // 兼容 old dartcome.com
    switch (path) {
      case 'account':
      case 'token':
        Cookies.set(path, value, {domain: `.${env.baseDomain}`})
        break
    }
  },

  clear () {
    Object.keys(vo).forEach(k => {
      // 兼容 old dartcome.com
      Cookies.remove(k, {domain: `.nutsb.com}`}) // old dev env
      Cookies.remove(k, {domain: `.${env.baseDomain}`}) // old prod env
      Cookies.remove(k)

      Cookies.remove(vo[k], {domain: `.${env.baseDomain}`})
    })
    localStorage.clear()
  }
}



// WEBPACK FOOTER //
// ./src/Store.js